export const FAQ_LIST_ATTEMPT = "FAQ_LIST_ATTEMPT";
export const FAQ_LIST_SUCCESS = "FAQ_LIST_SUCCESS";
export const FAQ_LIST_FAILED = "FAQ_LIST_FAILED";
/////////////////
export const FAQ_NEW_SUCCESS = "FAQ_NEW_SUCCESS";
export const FAQ_NEW_FAILED = "FAQ_NEW_FAILED";
